import * as React from "react"
import { Sparkles } from "lucide-react"
import { useBookingT } from "@/hooks/use-translations"
import { IntegrationCard } from "./IntegrationCard"
import type {
  Connection,
  IntegrationCatalogItem,
} from "@/features/integrations/api/types"

type Props = {
  items: IntegrationCatalogItem[]
  connectionsById: Record<string, Connection>
  onSelect: (id: string) => void
}

export function FeaturedSection({ items, connectionsById, onSelect }: Props) {
  const t = useBookingT()
  if (items.length === 0) return null

  return (
    <section className="space-y-3">
      <div className="flex items-center gap-2">
        <Sparkles className="size-4 text-brand-500" />
        <h2 className="text-lg font-semibold text-neutral-900">
          {t("integrations_featured_title", "Featured")}
        </h2>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {items.map((item) => (
          <IntegrationCard
            key={item.id}
            item={item}
            connection={connectionsById[item.id]}
            onClick={onSelect}
          />
        ))}
      </div>
    </section>
  )
}
